import { styled } from '@mui/material/styles';

const TypoBlock = styled('div')(({ theme }) => ({
  paddingBottom: theme.spacing(4),
  paddingTop: theme.spacing(4),
  fontSize: '0.7em',
}));

export default TypoBlock;